/**
 * Grundbuchmeldung API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MeldungsEmpfaengerSearchRequest { 
    bezeichnung?: string;
    sedexId?: string;
    erhaeltMeldungen?: boolean;
    erhaeltVertraulicheDaten?: boolean;
    erhaeltBasedelivery?: boolean;
    schemaversion?: MeldungsEmpfaengerSearchRequest.SchemaversionEnum;
    meldungsEmpfaengerSort?: MeldungsEmpfaengerSearchRequest.MeldungsEmpfaengerSortEnum;
    sortDirection?: MeldungsEmpfaengerSearchRequest.SortDirectionEnum;
    offset?: number;
    limit?: number;
    searchQuery?: string;
}
export namespace MeldungsEmpfaengerSearchRequest {
    export type SchemaversionEnum = 'ECH_0134_2_0';
    export const SchemaversionEnum = {
        ECH_0134_2_0: 'ECH_0134_2_0' as SchemaversionEnum
    };
    export type MeldungsEmpfaengerSortEnum = 'BEZEICHNUNG' | 'SEDEX_ID' | 'ERHAELTMELDUNGEN' | 'ERHAELTVERTRAULICHEDATEN' | 'ERHAELTBASEDELIVERY' | 'SCHEMAVERSION';
    export const MeldungsEmpfaengerSortEnum = {
        BEZEICHNUNG: 'BEZEICHNUNG' as MeldungsEmpfaengerSortEnum,
        SEDEX_ID: 'SEDEX_ID' as MeldungsEmpfaengerSortEnum,
        ERHAELTMELDUNGEN: 'ERHAELTMELDUNGEN' as MeldungsEmpfaengerSortEnum,
        ERHAELTVERTRAULICHEDATEN: 'ERHAELTVERTRAULICHEDATEN' as MeldungsEmpfaengerSortEnum,
        ERHAELTBASEDELIVERY: 'ERHAELTBASEDELIVERY' as MeldungsEmpfaengerSortEnum,
        SCHEMAVERSION: 'SCHEMAVERSION' as MeldungsEmpfaengerSortEnum
    };
    export type SortDirectionEnum = 'ASC' | 'DESC';
    export const SortDirectionEnum = {
        ASC: 'ASC' as SortDirectionEnum,
        DESC: 'DESC' as SortDirectionEnum
    };
}


